// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"26":"a9e0125f","420":"fb9faab2"}[chunkId] || chunkId) + "." + {"26":"e7222f8eb5ba93ca","99":"4930dec67da3c56f","420":"67ce2da4602294df"}[chunkId] + ".js";
};